export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-interpolate/src/round.js
// module id = ../../../../d3-interpolate/src/round.js
// module chunks = vendor